import React from 'react';

import * as css from './index.module.css';
import { i18n } from '../i18n';

// eg: <Screenshot src={testImg} alt='testImg' caption='this is a test img' theme='black'/>

export default function Screenshot({ src, path, alt, caption, theme, className }) {
    let screenshotClass = css.screenshot,
        wrapClass;

    // maybe the consumer should just pass a hex?
    switch (theme) {
        case 'black':
            wrapClass = css.wrapBlack;
            break;
        case 'blue':
            wrapClass = css.wrapBlue;
            break;
        case 'green':
            wrapClass = css.wrapGreen;
            break;
        default:
            wrapClass = css.wrap;
            break;
    }

    if (path) {
        src = i18n(path, { md : false });
    }

    if (className) {
        screenshotClass = [ className, screenshotClass ].join(' ');
    }

    return <div className={screenshotClass}>
        <div className={wrapClass} >
            <img src={src} alt={alt}/>
        </div>

        {caption ? <caption className={css.caption}>{caption}</caption> : null}
    </div>;
}
